<script>
    export default {
        name: 'MetaTags',
        props: {
            title: String,
            description: String,
            keywords: String,
            og_tags: Object,
        },
        metaInfo() {
            return {
                title: this.title || '安信信貸有限公司 PrimeCredit Limited',
                meta: [
                    {name: 'description', content: this.description || ''},
                    {name: 'keywords', content: this.keywords || ''},
                    ...this.og_tags_array,
                ],
            }
        },
        computed: {
            og_tags_array() {
                if (this.og_tags)
                    return Object.entries(this.og_tags).map(([name, content]) => {
                        const property = `og:${name}`;
                        return {
                            property,
                            content: content || '',
                            vmid: property
                        }
                    });
                return [];
            }
        },
        render: () => {
        },
    }
</script>
